import React from "react";
import { LoginFormField } from "@/components/form/FormField";
import { LoginHeader } from "../login-header";
import { SubmitButton } from "@/components/login/submit-button";
import { useFormContext } from "react-hook-form";
import { ContactButton } from "@/components/common/contact-button";
import { emailPasswordSchema } from "@/components/login/login-schema";
import { z } from "zod";

type LoginFormData = z.infer<typeof emailPasswordSchema>;

const Separator = () => {
  return (
    <div className="box-border content-stretch flex flex-col gap-2.5 items-start justify-start p-0 relative size-full">
      <div className="h-0 relative shrink-0 w-full">
        <div className="absolute bottom-0 left-0 right-0 top-[-1px]">
          <img
            alt=""
            className="block max-w-none size-full"
            src="/login-assets/separator-line.svg"
          />
        </div>
      </div>
    </div>
  );
};

export const LoginForm: React.FC<{ isLoading: boolean }> = ({ isLoading }) => {
  const {
    formState: { errors, isSubmitting, isValid },
    control,
  } = useFormContext<LoginFormData>();

  return (
    <>
      <LoginHeader />
      <div className="box-border content-stretch flex flex-col gap-6 items-start justify-start p-0 relative shrink-0 w-full">
        <LoginFormField
          label="이메일"
          type="email"
          placeholder="invector@example.com"
          error={!!errors.email}
          control={control}
          name="email"
        />

        <LoginFormField
          label="비밀번호"
          type="password"
          placeholder="••••••••"
          error={!!errors.password}
          control={control}
          name="password"
        />

        <SubmitButton
          loading={isLoading || isSubmitting}
          disabled={!isValid}
          text="인증번호 받기"
        />

        <div className="box-border content-stretch flex flex-col gap-2.5 items-start justify-start px-0 py-2.5 relative shrink-0 w-full">
          <div className="box-border content-stretch flex flex-col gap-2.5 items-start justify-start p-0 relative shrink-0 w-full">
            <Separator />
          </div>
        </div>
      </div>
      <div className="flex items-center justify-center self-stretch gap-1">
        <span className="label-1-normal-medium text-neutral-500">
          문제가 생겼나요?{" "}
        </span>
        <ContactButton className="!text-neutral-500" />
      </div>
    </>
  );
};
